"use client";

import { useEffect } from "react";
import { trackSectorView } from "./ga-events";

export function TrackSectorView({ sectorName }: { sectorName: string }) {
  useEffect(() => {
    trackSectorView(sectorName);
  }, [sectorName]);

  return null;
}
